import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SubscriptionOptionWhenGasExpiresComponent } from '../my-wehicles-web-view/subscription-option-when-gas-expires/subscription-option-when-gas-expires.component';

@NgModule({
  declarations: [SubscriptionOptionWhenGasExpiresComponent],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ],
  imports: [CommonModule],
})
export class WebviewsModule {}
